<app-monitor-layout #monitorContainer
  [test]="test"
  [testLoading]="testLoading$ | async"
  [patient]="patient"
  [bundle]="bundle"
  [screen]="currentDeviceScreen"
  [isTestDone]="isTestDone"
  [isTestSyncing]="isTestSyncing"
  [deviceLoading]="deviceLoading$ | async"
  [device]="device"
  [batteryPercentage]="batteryPercentage"
  [streamPopupVisible]="streamPopupVisible"
  [isSingleImage]="isSingleImage"
  [isV2Streaming]="isV2Streaming"
  [deviceActionLoading]="deviceActionLoading"
  [isLoading]="isLoading"
  [headsetAlignment]="headsetAlignment"
  (onClose)="close()"
  (onStreamOpen)="openStream($event)"
  (onStreamClose)="closeStream()"
  (onActionClicked)="onActionClicked($event)">

  <div class="monitor_container-column monitor_container-column--single-or-double">
    @if (osColors.length) {
      <div class="monitor_graph-box monitor_graph-box--single" >
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <div class="monitor_graph-title">{{ 'left' | translate | titlecase }}</div>
        <app-color-circles
          [colors]="osColors">
        </app-color-circles>
      </div>
    }
    @if (odColors.length) {
      <div class="monitor_graph-box monitor_graph-box--single" >
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <div class="monitor_graph-title">{{ 'right' | translate | titlecase }}</div>
        <app-color-circles
          [colors]="odColors">
        </app-color-circles>
      </div>
    }
    @if (ouColors.length) {
      <div class="monitor_graph-box monitor_graph-box--single" >
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <app-color-circles
          [colors]="ouColors">
        </app-color-circles>
      </div>
    }
  </div>

  <div class="monitor_container-column">
    @if (osColors.length) {
      <div class="monitor_graph-box">
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <div class="monitor_graph-title">{{ 'left' | translate | titlecase }}</div>
        <app-percentage-circle
          id="test-percentage-left"
          class="monitor_circle-box"
          [percentage]="getPercentageDone(osColors)">
        </app-percentage-circle>
      </div>
    }
    @if (odColors.length) {
      <div class="monitor_graph-box">
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <div class="monitor_graph-title">{{ 'right' | translate | titlecase }}</div>
        <app-percentage-circle
          id="test-percentage-right"
          class="monitor_circle-box"
          [percentage]="getPercentageDone(odColors)">
        </app-percentage-circle>
      </div>
    }
    @if (ouColors.length) {
      <div class="monitor_graph-box">
        @if (isTestSyncing) {
          <div class="monitor_sync-box"><div class="monitor_overlay-text text--blink">{{'syncing' | translate | titlecase}}...</div></div>
        }
        <app-percentage-circle
          id="test-percentage-both"
          class="monitor_circle-box"
          [percentage]="getPercentageDone(ouColors)">
        </app-percentage-circle>
      </div>
    }
  </div>
</app-monitor-layout>